<header class="meta">
    <span class="type">
        @for (type of types(); track type.label) {
            <span class="type-item">
                <span class="type-icon" [class]="type.icon"></span>
                <span>{{ type.label }}</span>
            </span>
        }
    </span>
    <span class="updated">
        Updated {{ item().updatedAt | relativeTime }}
        @if (topTags().length > 0) {
            <span class="tags-meta">
                <span class="tags-label">Top Tags:</span>
                <app-tag-list
                    class="tags"
                    [ngModel]="topTagOptions()"
                    [disabled]="true"
                />
            </span>
        }
    </span>
    <!--    Marketers have read-only access -->
    @if (!isMarketer()) {
        <button
            class="result-actions"
            [matMenuTriggerFor]="rowMenu"
            mat-icon-button
            type="button"
            aria-label="Interactive actions"
        >
            <span class="icon-overflow-filled"></span>
        </button>
    }
</header>

<a class="content" [routerLink]="producerLink()">
    <img class="image" [src]="imageSrc()" [alt]="item().name" />

    <div class="details">
        <h4 class="name">{{ item().name }}</h4>
        <p class="prompt">{{ item().prompt }}</p>
        <span class="tenant">{{ item().tenantName }}</span>
        <div class="schedule-row">
            <tools-badge [variant]="badgeVariant()">
                {{ displayState() }}
            </tools-badge>
            @if (displayState() !== "DRAFT" && startDate(); as start) {
                <app-date-range-bar
                    class="dates"
                    [startDate]="start"
                    [endDate]="endDate()"
                    [colorDisabled]="displayState() === 'PAUSED'"
                />
            }
        </div>
    </div>

    <div class="stats">
        @if (item().isPoll) {
            <div class="stat">
                <span class="stat-label">Votes</span>
                <span class="stat-value">
                    {{ item().pollStats?.votes ?? "—" }}
                </span>
            </div>
            <div class="stat">
                <span class="stat-label">Unique Participants</span>
                <span class="stat-value">
                    {{ item().pollStats?.uniqueParticipants ?? "—" }}
                </span>
            </div>
            <div class="stat">
                <span class="stat-label">Top Selection</span>
                <span class="stat-value">
                    @for (line of topSelectionLines(); track $index) {
                        <span class="stat-line">{{ line }}</span>
                    }
                </span>
            </div>
        } @else {
            <div class="stat">
                <span class="stat-label">Submissions</span>
                <span class="stat-value">
                    {{ item().freeformStats?.submissionCount ?? "—" }}
                </span>
            </div>
            <div class="stat">
                <span class="stat-label">Unique Participants</span>
                <span class="stat-value">
                    {{ item().freeformStats?.uniqueParticipants ?? "—" }}
                </span>
            </div>
            <div class="stat">
                <span class="stat-label">Queued</span>
                <span class="stat-value">
                    {{ item().freeformStats?.queuedSubmissions ?? "—" }}
                </span>
            </div>
        }
    </div>
</a>

<mat-menu #rowMenu="matMenu">
    @for (menuItem of menuItems(); track menuItem.action) {
        @if (menuItem.link) {
            <button mat-menu-item type="button" [routerLink]="menuItem.link">
                {{ menuItem.label }}
            </button>
        } @else {
            <button
                mat-menu-item
                type="button"
                (click)="onAction(menuItem.action)"
            >
                {{ menuItem.label }}
            </button>
        }
    }
</mat-menu>
